import { database } from "../config"
import { ref, onValue, off } from "firebase/database"
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"

export const fetchBlog = createAsyncThunk(
    "blog/fetchBlog",
    async (_, { dispatch, getState }) => {
        const blogRef = ref(database, "blog/")
        dispatch(setLoading(true))

        return new Promise((resolve, reject) => {
            const unsubscribe = onValue(
                blogRef,
                (snapshot) => {
                    const data = snapshot.val()
                    const userData = getState().userData.data
                    const isEducator = userData?.is_educator === true
                    let blog = []
                    if (data) {
                        blog = Object.entries(data)
                            .map(([id, blog]) => ({
                                id,
                                ...blog,
                            }))
                            .filter(blog =>
                                blog.visible &&
                                (!blog.private || (blog.private && isEducator))
                            )
                        dispatch(setBlog(blog))
                        dispatch(setLoading(false))
                    } else {
                        dispatch(setBlog([]))
                        dispatch(setLoading(false))
                    }
                    resolve(blog)
                },
                (error) => {
                    dispatch(setError(error))
                    dispatch(setLoading(false))
                    reject(error)
                }
            )
            return () => off(blogRef, "value", unsubscribe)
        })
    }
)

const blogSlice = createSlice({
    name: "blog",
    initialState: {
        blogData: null,
        loading: true,
        error: null,
    },
    reducers: {
        setBlog: (state, action) => {
            state.blogData = action.payload
        },
        setLoading: (state, action) => {
            state.loading = action.payload
        },
        setError: (state, action) => {
            state.error = action.payload
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchBlog.pending, (state) => {
                state.loading = true
                state.error = null
            })
            .addCase(fetchBlog.fulfilled, (state) => {
                state.loading = false
            })
            .addCase(fetchBlog.rejected, (state, action) => {
                state.loading = false
                state.error = action.payload
            })
    },
})

export const { setBlog, setLoading, setError } = blogSlice.actions
export default blogSlice.reducer